import { Link } from "react-router-dom";
import { useTranslation, useLang } from "@/lib/i18n";

const SiteFooter = () => {
  const t = useTranslation();
  const { lang } = useLang();
  const privacyHref = lang === "pl" ? "/pl/privacy" : "/privacy";

  return (
    <footer className="mt-16 pt-4 border-t border-border/30 flex items-center justify-center gap-4 py-2">
      <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground/80">
        © {new Date().getFullYear()} Chris Scibiorek
      </p>
      <span className="font-mono text-[10px] text-muted-foreground/40">·</span>
      <Link
        to={privacyHref}
        className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground/80 hover:text-foreground transition-colors"
      >
        {t.legal.footer.privacy}
      </Link>
    </footer>
  );
};

export default SiteFooter;
